import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NotificationContentFormState } from './notification-content-form.reducer';

export const NotificationContentFormKey = 'notification-content-form';

export const getNotificationContentFormState = createFeatureSelector<NotificationContentFormState>(
  NotificationContentFormKey,
);

export const getNotificationContentFormModel = createSelector(
  getNotificationContentFormState,
  ({ model }) => model,
);

export const getNotificationContentFormError = createSelector(
  getNotificationContentFormState,
  ({ error }) => error,
);

export const getNotificationContentFormLoaded = createSelector(
  getNotificationContentFormState,
  ({ loaded }) => loaded,
);

export const getNotificationContentFormMode = createSelector(
  getNotificationContentFormState,
  ({ mode }) => mode,
);
